"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Format digital collection for client FE
 * Format digital collection api module
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateApi = exports.PrivateApiFactory = exports.PrivateApiFp = exports.PrivateApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * PrivateApi - axios parameter creator
 * @export
 */
var PrivateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary add an item to a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {AddBasketItemRequest} [addBasketItemRequest] Add basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBasketItem: function (initiativeLogicId, basketType, addBasketItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('addBasketItem', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('addBasketItem', 'basketType', basketType);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addBasketItemRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary basket checkout
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {CheckoutRequest} [checkoutRequest] Request containing information for checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout: function (initiativeLogicId, basketType, checkoutRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('checkout', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('checkout', 'basketType', basketType);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets/checkout"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(checkoutRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete physically an item from a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketItem: function (initiativeLogicId, basketType, catalogGroupProductLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteBasketItem', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('deleteBasketItem', 'basketType', basketType);
                    // verify required parameter 'catalogGroupProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteBasketItem', 'catalogGroupProductLogicId', catalogGroupProductLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets/products/{catalogGroupProductLogicId}"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)))
                        .replace("{".concat("catalogGroupProductLogicId", "}"), encodeURIComponent(String(catalogGroupProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary update basket item (e.g. quantity)
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be updated
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {UpdateBasketItemRequest} [updateBasketItemRequest] Update basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editBasketItem: function (initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('editBasketItem', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'catalogGroupProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('editBasketItem', 'catalogGroupProductLogicId', catalogGroupProductLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('editBasketItem', 'basketType', basketType);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets/products/{catalogGroupProductLogicId}"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)))
                        .replace("{".concat("catalogGroupProductLogicId", "}"), encodeURIComponent(String(catalogGroupProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateBasketItemRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary get user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket: function (initiativeLogicId, basketType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getBasket', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('getBasket', 'basketType', basketType);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary get user basket preview to confirm the order
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketPreview: function (initiativeLogicId, basketType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getBasketPreview', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'basketType' is not null or undefined
                    (0, common_1.assertParamExists)('getBasketPreview', 'basketType', basketType);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/baskets/preview"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (basketType !== undefined) {
                        localVarQueryParameter['basketType'] = basketType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the list of brands filtered by user\'s groups
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsPrivate: function (initiativeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getBrandsPrivate', 'initiativeLogicId', initiativeLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/brands"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Starts a payment checkout session and redirects to the url of the payment system
         * @param {string} redemptionLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutUrl: function (redemptionLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'redemptionLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCheckoutUrl', 'redemptionLogicId', redemptionLogicId);
                    localVarPath = "/private/redemptions/{redemptionLogicId}/checkout"
                        .replace("{".concat("redemptionLogicId", "}"), encodeURIComponent(String(redemptionLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Digital Collection CMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDigitalCollectionPrivate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/private/cms/digitalCollection";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user balance available for an initiative
         * @param {string} initiativeLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits: function (initiativeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getLimits', 'initiativeLogicId', initiativeLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/limits"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the whole product by product logic id
         * @param {string} initiativeLogicId initiative logic id
         * @param {string} productLogicId product logic id
         * @param {Array<string>} [catalogGroupLogicIds] list of comma separated catalog group logic ids - if not valued will be evaluated by the application
         * @param {string} [relatedProductLogicId] related product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrivate: function (initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductPrivate', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'productLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductPrivate', 'productLogicId', productLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/products/{productLogicId}"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)))
                        .replace("{".concat("productLogicId", "}"), encodeURIComponent(String(productLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (catalogGroupLogicIds) {
                        localVarQueryParameter['catalogGroupLogicIds'] = catalogGroupLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (relatedProductLogicId !== undefined) {
                        localVarQueryParameter['relatedProductLogicId'] = relatedProductLogicId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {string} initiativeLogicId initiative logic id
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering  To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivate: function (page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'page' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivate', 'page', page);
                    // verify required parameter 'size' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivate', 'size', size);
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivate', 'initiativeLogicId', initiativeLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/products"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (isForSlider !== undefined) {
                        localVarQueryParameter['isForSlider'] = isForSlider;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (searchText !== undefined) {
                        localVarQueryParameter['searchText'] = searchText;
                    }
                    if (tagLogicIds) {
                        localVarQueryParameter['tagLogicIds'] = tagLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (brandLogicIds) {
                        localVarQueryParameter['brandLogicIds'] = brandLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (walletConfigurationLogicIds) {
                        localVarQueryParameter['walletConfigurationLogicIds'] = walletConfigurationLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (sectorLogicIds) {
                        localVarQueryParameter['sectorLogicIds'] = sectorLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (minAmount !== undefined) {
                        localVarQueryParameter['minAmount'] = minAmount;
                    }
                    if (maxAmount !== undefined) {
                        localVarQueryParameter['maxAmount'] = maxAmount;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {string} initiativeLogicId initiative logic id
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {Array<string>} [eligibleClusterLogicIds] list of comma separated eligible cluster logic ids to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivateEligible: function (initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivateEligible', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'page' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivateEligible', 'page', page);
                    // verify required parameter 'size' is not null or undefined
                    (0, common_1.assertParamExists)('getProductsPreviewPrivateEligible', 'size', size);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/products/eligible"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (isForSlider !== undefined) {
                        localVarQueryParameter['isForSlider'] = isForSlider;
                    }
                    if (searchText !== undefined) {
                        localVarQueryParameter['searchText'] = searchText;
                    }
                    if (tagLogicIds) {
                        localVarQueryParameter['tagLogicIds'] = tagLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (brandLogicIds) {
                        localVarQueryParameter['brandLogicIds'] = brandLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (walletConfigurationLogicIds) {
                        localVarQueryParameter['walletConfigurationLogicIds'] = walletConfigurationLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (sectorLogicIds) {
                        localVarQueryParameter['sectorLogicIds'] = sectorLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (minAmount !== undefined) {
                        localVarQueryParameter['minAmount'] = minAmount;
                    }
                    if (maxAmount !== undefined) {
                        localVarQueryParameter['maxAmount'] = maxAmount;
                    }
                    if (eligibleClusterLogicIds) {
                        localVarQueryParameter['eligibleClusterLogicIds'] = eligibleClusterLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get purchase parameters for a product
         * @param {string} initiativeLogicId
         * @param {string} catalogGroupLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParametersForProduct: function (initiativeLogicId, catalogGroupLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getPurchaseParametersForProduct', 'initiativeLogicId', initiativeLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getPurchaseParametersForProduct', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/products/{catalogGroupLogicId}/purchase-parameters"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the sectors structure by catalog filtered by user\'s groups - Sectors with zero available products won\'t be returned
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorsPrivate: function (initiativeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getSectorsPrivate', 'initiativeLogicId', initiativeLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/sectors"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the list of tags filtered by user\'s groups
         * @param {string} initiativeLogicId initiative logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsPrivate: function (initiativeLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'initiativeLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getTagsPrivate', 'initiativeLogicId', initiativeLogicId);
                    localVarPath = "/private/initiatives/{initiativeLogicId}/tags"
                        .replace("{".concat("initiativeLogicId", "}"), encodeURIComponent(String(initiativeLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PrivateApiAxiosParamCreator = PrivateApiAxiosParamCreator;
/**
 * PrivateApi - functional programming interface
 * @export
 */
var PrivateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PrivateApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary add an item to a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {AddBasketItemRequest} [addBasketItemRequest] Add basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBasketItem: function (initiativeLogicId, basketType, addBasketItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addBasketItem(initiativeLogicId, basketType, addBasketItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary basket checkout
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {CheckoutRequest} [checkoutRequest] Request containing information for checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout: function (initiativeLogicId, basketType, checkoutRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkout(initiativeLogicId, basketType, checkoutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete physically an item from a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketItem: function (initiativeLogicId, basketType, catalogGroupProductLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBasketItem(initiativeLogicId, basketType, catalogGroupProductLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update basket item (e.g. quantity)
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be updated
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {UpdateBasketItemRequest} [updateBasketItemRequest] Update basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editBasketItem: function (initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.editBasketItem(initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket: function (initiativeLogicId, basketType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBasket(initiativeLogicId, basketType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get user basket preview to confirm the order
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketPreview: function (initiativeLogicId, basketType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBasketPreview(initiativeLogicId, basketType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the list of brands filtered by user\'s groups
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsPrivate: function (initiativeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBrandsPrivate(initiativeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Starts a payment checkout session and redirects to the url of the payment system
         * @param {string} redemptionLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutUrl: function (redemptionLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCheckoutUrl(redemptionLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Digital Collection CMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDigitalCollectionPrivate: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCmsDigitalCollectionPrivate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user balance available for an initiative
         * @param {string} initiativeLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits: function (initiativeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLimits(initiativeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the whole product by product logic id
         * @param {string} initiativeLogicId initiative logic id
         * @param {string} productLogicId product logic id
         * @param {Array<string>} [catalogGroupLogicIds] list of comma separated catalog group logic ids - if not valued will be evaluated by the application
         * @param {string} [relatedProductLogicId] related product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrivate: function (initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductPrivate(initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {string} initiativeLogicId initiative logic id
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering  To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivate: function (page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductsPreviewPrivate(page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {string} initiativeLogicId initiative logic id
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {Array<string>} [eligibleClusterLogicIds] list of comma separated eligible cluster logic ids to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivateEligible: function (initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductsPreviewPrivateEligible(initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get purchase parameters for a product
         * @param {string} initiativeLogicId
         * @param {string} catalogGroupLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParametersForProduct: function (initiativeLogicId, catalogGroupLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseParametersForProduct(initiativeLogicId, catalogGroupLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the sectors structure by catalog filtered by user\'s groups - Sectors with zero available products won\'t be returned
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorsPrivate: function (initiativeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSectorsPrivate(initiativeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the list of tags filtered by user\'s groups
         * @param {string} initiativeLogicId initiative logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsPrivate: function (initiativeLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagsPrivate(initiativeLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PrivateApiFp = PrivateApiFp;
/**
 * PrivateApi - factory interface
 * @export
 */
var PrivateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PrivateApiFp)(configuration);
    return {
        /**
         *
         * @summary add an item to a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {AddBasketItemRequest} [addBasketItemRequest] Add basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBasketItem: function (initiativeLogicId, basketType, addBasketItemRequest, options) {
            return localVarFp.addBasketItem(initiativeLogicId, basketType, addBasketItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary basket checkout
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {CheckoutRequest} [checkoutRequest] Request containing information for checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout: function (initiativeLogicId, basketType, checkoutRequest, options) {
            return localVarFp.checkout(initiativeLogicId, basketType, checkoutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete physically an item from a user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketItem: function (initiativeLogicId, basketType, catalogGroupProductLogicId, options) {
            return localVarFp.deleteBasketItem(initiativeLogicId, basketType, catalogGroupProductLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update basket item (e.g. quantity)
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be updated
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {UpdateBasketItemRequest} [updateBasketItemRequest] Update basket item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editBasketItem: function (initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options) {
            return localVarFp.editBasketItem(initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get user basket for an initiative
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket: function (initiativeLogicId, basketType, options) {
            return localVarFp.getBasket(initiativeLogicId, basketType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get user basket preview to confirm the order
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {BasketTypeEnum} basketType basket type based on purchase mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasketPreview: function (initiativeLogicId, basketType, options) {
            return localVarFp.getBasketPreview(initiativeLogicId, basketType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the list of brands filtered by user\'s groups
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsPrivate: function (initiativeLogicId, options) {
            return localVarFp.getBrandsPrivate(initiativeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Starts a payment checkout session and redirects to the url of the payment system
         * @param {string} redemptionLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutUrl: function (redemptionLogicId, options) {
            return localVarFp.getCheckoutUrl(redemptionLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Digital Collection CMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDigitalCollectionPrivate: function (options) {
            return localVarFp.getCmsDigitalCollectionPrivate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user balance available for an initiative
         * @param {string} initiativeLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits: function (initiativeLogicId, options) {
            return localVarFp.getLimits(initiativeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the whole product by product logic id
         * @param {string} initiativeLogicId initiative logic id
         * @param {string} productLogicId product logic id
         * @param {Array<string>} [catalogGroupLogicIds] list of comma separated catalog group logic ids - if not valued will be evaluated by the application
         * @param {string} [relatedProductLogicId] related product logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrivate: function (initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options) {
            return localVarFp.getProductPrivate(initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {string} initiativeLogicId initiative logic id
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering  To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivate: function (page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options) {
            return localVarFp.getProductsPreviewPrivate(page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get paged list of products for an initiative
         * @param {string} initiativeLogicId initiative logic id
         * @param {number} page requested page number
         * @param {number} size requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
         * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
         * @param {Array<string>} [tagLogicIds] list of comma separated tags
         * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
         * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
         * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
         * @param {number} [minAmount] amount range lower bound value to be used to filter the results
         * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
         * @param {Array<string>} [eligibleClusterLogicIds] list of comma separated eligible cluster logic ids to be used to filter the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPreviewPrivateEligible: function (initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options) {
            return localVarFp.getProductsPreviewPrivateEligible(initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get purchase parameters for a product
         * @param {string} initiativeLogicId
         * @param {string} catalogGroupLogicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseParametersForProduct: function (initiativeLogicId, catalogGroupLogicId, options) {
            return localVarFp.getPurchaseParametersForProduct(initiativeLogicId, catalogGroupLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the sectors structure by catalog filtered by user\'s groups - Sectors with zero available products won\'t be returned
         * @param {string} initiativeLogicId logic id of the initiative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorsPrivate: function (initiativeLogicId, options) {
            return localVarFp.getSectorsPrivate(initiativeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the list of tags filtered by user\'s groups
         * @param {string} initiativeLogicId initiative logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsPrivate: function (initiativeLogicId, options) {
            return localVarFp.getTagsPrivate(initiativeLogicId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PrivateApiFactory = PrivateApiFactory;
/**
 * PrivateApi - object-oriented interface
 * @export
 * @class PrivateApi
 * @extends {BaseAPI}
 */
var PrivateApi = /** @class */ (function (_super) {
    __extends(PrivateApi, _super);
    function PrivateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary add an item to a user basket for an initiative
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {AddBasketItemRequest} [addBasketItemRequest] Add basket item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.addBasketItem = function (initiativeLogicId, basketType, addBasketItemRequest, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).addBasketItem(initiativeLogicId, basketType, addBasketItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary basket checkout
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {CheckoutRequest} [checkoutRequest] Request containing information for checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.checkout = function (initiativeLogicId, basketType, checkoutRequest, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).checkout(initiativeLogicId, basketType, checkoutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete physically an item from a user basket for an initiative
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.deleteBasketItem = function (initiativeLogicId, basketType, catalogGroupProductLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).deleteBasketItem(initiativeLogicId, basketType, catalogGroupProductLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update basket item (e.g. quantity)
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {string} catalogGroupProductLogicId logic id of the catalog group product (basket item) to be updated
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {UpdateBasketItemRequest} [updateBasketItemRequest] Update basket item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.editBasketItem = function (initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).editBasketItem(initiativeLogicId, catalogGroupProductLogicId, basketType, updateBasketItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get user basket for an initiative
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getBasket = function (initiativeLogicId, basketType, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getBasket(initiativeLogicId, basketType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get user basket preview to confirm the order
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {BasketTypeEnum} basketType basket type based on purchase mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getBasketPreview = function (initiativeLogicId, basketType, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getBasketPreview(initiativeLogicId, basketType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the list of brands filtered by user\'s groups
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getBrandsPrivate = function (initiativeLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getBrandsPrivate(initiativeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Starts a payment checkout session and redirects to the url of the payment system
     * @param {string} redemptionLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getCheckoutUrl = function (redemptionLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getCheckoutUrl(redemptionLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Digital Collection CMS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getCmsDigitalCollectionPrivate = function (options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getCmsDigitalCollectionPrivate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user balance available for an initiative
     * @param {string} initiativeLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getLimits = function (initiativeLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getLimits(initiativeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the whole product by product logic id
     * @param {string} initiativeLogicId initiative logic id
     * @param {string} productLogicId product logic id
     * @param {Array<string>} [catalogGroupLogicIds] list of comma separated catalog group logic ids - if not valued will be evaluated by the application
     * @param {string} [relatedProductLogicId] related product logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getProductPrivate = function (initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getProductPrivate(initiativeLogicId, productLogicId, catalogGroupLogicIds, relatedProductLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get paged list of products for an initiative
     * @param {number} page requested page number
     * @param {number} size requested result page size
     * @param {string} initiativeLogicId initiative logic id
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering  To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
     * @param {Array<string>} [tagLogicIds] list of comma separated tags
     * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
     * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
     * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
     * @param {number} [minAmount] amount range lower bound value to be used to filter the results
     * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getProductsPreviewPrivate = function (page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getProductsPreviewPrivate(page, size, initiativeLogicId, includeMetadata, isForSlider, sort, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get paged list of products for an initiative
     * @param {string} initiativeLogicId initiative logic id
     * @param {number} page requested page number
     * @param {number} size requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {boolean} [isForSlider] flag that indicates if only products inside sectors marked as \&#39;isForSlider\&#39; must be returned
     * @param {string} [searchText] free text to be searched inside product description/title in order to filter the results
     * @param {Array<string>} [tagLogicIds] list of comma separated tags
     * @param {Array<string>} [brandLogicIds] list of comma separated brand logic ids to be used to filter the results
     * @param {Array<string>} [walletConfigurationLogicIds] wallet configuration logics ids
     * @param {Array<string>} [sectorLogicIds] list of comma separated sector logic ids to be used to filter the results
     * @param {number} [minAmount] amount range lower bound value to be used to filter the results
     * @param {number} [maxAmount] amount range upper bound value to be used to filter the results
     * @param {Array<string>} [eligibleClusterLogicIds] list of comma separated eligible cluster logic ids to be used to filter the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getProductsPreviewPrivateEligible = function (initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getProductsPreviewPrivateEligible(initiativeLogicId, page, size, includeMetadata, sort, isForSlider, searchText, tagLogicIds, brandLogicIds, walletConfigurationLogicIds, sectorLogicIds, minAmount, maxAmount, eligibleClusterLogicIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get purchase parameters for a product
     * @param {string} initiativeLogicId
     * @param {string} catalogGroupLogicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getPurchaseParametersForProduct = function (initiativeLogicId, catalogGroupLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getPurchaseParametersForProduct(initiativeLogicId, catalogGroupLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the sectors structure by catalog filtered by user\'s groups - Sectors with zero available products won\'t be returned
     * @param {string} initiativeLogicId logic id of the initiative
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getSectorsPrivate = function (initiativeLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getSectorsPrivate(initiativeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the list of tags filtered by user\'s groups
     * @param {string} initiativeLogicId initiative logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.getTagsPrivate = function (initiativeLogicId, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).getTagsPrivate(initiativeLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PrivateApi;
}(base_1.BaseAPI));
exports.PrivateApi = PrivateApi;
